// extracted by mini-css-extract-plugin
export default {"zoomModal":"T1-z"};